import NameLang from './name-lang'

export default NameLang
